import { useParams } from 'react-router';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import usePatchHook from '../../customHooks/usePatchHook';
import loadable from '@loadable/component';
import CreateIcon from '../../Icons/Create';
import usePostHook from '../../customHooks/usePostHook';

const EditDeliveryChargeComponent = loadable(
  () => import("../../components/DeliveryCharge/EditDeliveryCharge")
);

const EditDeliveryCharge = () => {
  const { id, templateID } = useParams()

  const { refetch } = useGetHook({
    queryKey: [`delivery-charge-${id}`],
    url: `${APIS.DELIVERY_CHARGE}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`delivery-charge-${id}`],
    navigateURL: `/delivery-charge/${templateID}`,
  });

  const { mutateAsync:updateReturnCharnge, isPostLoading: returnChargeIsLoading } = usePostHook({
    queryKey: [`delivery-charge-${id}`],
    navigateURL:"",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.DELIVERY_CHARGE}${id}/`;
    let formData = {
      base_price: values.base_price,
      base_weight: values.base_weight,
      delivery_charge_template: templateID,
      destination_branch: values.destination_branch,
      id: values.id,
      pickup_branch: values.pickup_branch,
      price_for_exceed_weight: values.price_for_exceed_weight,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const handleUpdateReturnCharge = async (values: any, setError: any) => {
    const url = `${APIS.DELIVERY_CHARGE}${id}/update-return-delivery-charge-status/`;
    console.log(values)
    let formData = {
      return_status: values.return_status?.map((item:any)=>item.id),
      amount: values?.amount
    };
    try {
      await updateReturnCharnge({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Delivery Charge</span>
      </div>
      <EditDeliveryChargeComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
        handleUpdateReturnCharge={handleUpdateReturnCharge}
        returnChargeIsLoading={returnChargeIsLoading}
      />
    </>
  )
}

export default EditDeliveryCharge
